import { useFlag } from '@/features/unleash';
import loadable from '@loadable/component';
import type { NoteReminderProps } from '@/components/NoteReminder/components/NoteReminder';

const NoteReminder = loadable(
  () => import('@/components/NoteReminder/components/NoteReminder/NoteReminder')
);

const FlaggedNoteReminder = (props: NoteReminderProps) => {
  const featureFlag = useFlag({ name: 'mono-note-reminder' });
  const isFeatureEnabled = featureFlag.flagsReady && featureFlag.enabled;
  if (!isFeatureEnabled) return null;
  return <NoteReminder {...props} />;
};

export default FlaggedNoteReminder;
